module.exports = __webpack_public_path__ + "img/login.2d3cc42a.png";